export default __webpack_public_path__ + "8d6b4bb146b3ae2ccaf3606dccb5ab29.png";